"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseEQL = void 0;
const fixWhereClauseNesting_1 = require("./fixWhereClauseNesting");
const nearley_1 = __importDefault(require("nearley"));
const eql_1 = __importDefault(require("./grammer/eql"));
// Create a Parser object from our grammar.
const parser = new nearley_1.default.Parser(nearley_1.default.Grammar.fromCompiled(eql_1.default));
// Save initial state for reuse
const initialParserState = parser.save();
const ParseEQL = (eql) => {
    // Reset parser before using
    parser.restore(initialParserState);
    // Parse eql & get result
    const results = parser.feed(eql).results;
    // No result -> invalid input
    if (!parser.results.length)
        throw new Error("Invalid EQL");
    // result is first index
    const query = results[0];
    query.where = (0, fixWhereClauseNesting_1.fixWhereClauseNesting)(eql, query.where);
    return query;
};
exports.ParseEQL = ParseEQL;
